/**
 * Cart Fabric Quantity Handler
 * Loaded as external JS file so it persists across DOM morphing.
 * Uses capture-phase event delegation with composedPath() for
 * shadow DOM compatibility — guaranteed to catch clicks.
 */
(function () {
  var debounceTimers = {};
  var inFlight = {};
  var pendingUpdates = {};

  function formatLength(val) {
    return val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
  }

  function sendUpdate(itemKey, pricePerMeter, length) {
    if (inFlight[itemKey]) {
      pendingUpdates[itemKey] = { pricePerMeter: pricePerMeter, length: length };
      return;
    }
    inFlight[itemKey] = true;

    var quantityInCm = Math.round(length * 100);
    var calculatedPrice = Math.round(pricePerMeter * length);

    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantityInCm,
        properties: {
          _is_fabric: 'true',
          _fabric_quantity: length.toFixed(2),
          _fabric_price: calculatedPrice,
          _price_per_meter: pricePerMeter,
        },
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              data: {
                itemCount: cart.item_count,
                sections: cart.sections,
              },
            },
          })
        );
      })
      .catch(function (err) {
        console.error('Error updating cart:', err);
      })
      .finally(function () {
        delete inFlight[itemKey];
        if (pendingUpdates[itemKey]) {
          var p = pendingUpdates[itemKey];
          delete pendingUpdates[itemKey];
          sendUpdate(itemKey, p.pricePerMeter, p.length);
        }
      });
  }

  // Capture-phase listener on document — fires BEFORE any target/bubble handlers.
  // composedPath() ensures clicks inside shadow DOM are detected.
  document.addEventListener(
    'click',
    function (e) {
      var path = e.composedPath();
      var btn = null;
      var delta = 0;

      // Walk the composed path to find a fabric +/- button
      for (var i = 0; i < path.length; i++) {
        var el = path[i];
        if (!el.classList) continue;
        if (el.classList.contains('cart-fabric-qty__plus')) {
          btn = el;
          delta = 0.25;
          break;
        }
        if (el.classList.contains('cart-fabric-qty__minus')) {
          btn = el;
          delta = -0.25;
          break;
        }
      }

      if (!btn) return;

      var selector = btn.closest('.cart-fabric-length');
      if (!selector) return;

      e.preventDefault();

      var pricePerMeter = parseInt(selector.dataset.pricePerMeter) || 0;
      var itemKey = selector.dataset.itemKey;
      if (!pricePerMeter || !itemKey) return;

      var currentLength = parseFloat(selector.dataset.currentLength) || 1;
      var maxLength = parseFloat(selector.dataset.maxLength) || 0;
      var newLength = Math.round((currentLength + delta) * 4) / 4;
      if (newLength < 1) return;
      // Enforce inventory limit (max meters in stock)
      if (maxLength > 0 && newLength > maxLength) return;

      // Update DOM immediately for instant feedback
      selector.dataset.currentLength = newLength.toString();
      var input = selector.querySelector('.cart-fabric-qty__input');
      if (input) input.value = formatLength(newLength);
      var minus = selector.querySelector('.cart-fabric-qty__minus');
      if (minus) minus.disabled = newLength <= 1;
      var plus = selector.querySelector('.cart-fabric-qty__plus');
      if (plus) plus.disabled = maxLength > 0 && newLength >= maxLength;

      // Debounce: batch rapid clicks into one API call
      clearTimeout(debounceTimers[itemKey]);
      debounceTimers[itemKey] = setTimeout(function () {
        sendUpdate(itemKey, pricePerMeter, newLength);
      }, 400);
    },
    true
  ); // <-- CAPTURE phase
})();
